import React, {Component} from 'react';
import FilterByConfirmed from 'components/molecules/filter-by-confirmed';
import FilterByOrder from 'components/organisms/filter-by-order';
import FilterBySalary from 'components/organisms/filter-by-salary';
import FilterByPoints from 'components/organisms/filter-by-points';
import ExposureMode from 'components/molecules/exposure-mode';
import UniquePlayersQuantity from 'components/molecules/unique-players-quantity';
import LineupsQuantity from 'components/organisms/lineups-quantity';
import OpposingPitchers from 'components/organisms/opposing-pitchers';
import SelectSalaryCap from 'components/organisms/select-salary-cap';
import ProjectedOwnershipCap from 'components/organisms/projected-ownership-cap';
import MLBHittersStack from 'components/organisms/mlb-hitter-stacking';
import OptimizeButton from 'components/molecules/optimize-button';
import SelectLineupResolver from 'components/molecules/select-lineup-resolver';
import PrioritizeCompletingLineupsAboveExp from 'components/molecules/prioritize-completing-lineups-above-exp';
import RangeOfOutcomesByPositions from 'components/organisms/range-of-outcomes/range-of-outcomes-by-positions';
import ProjectionPointsType from 'components/molecules/projection-points-type';
import NonControlledHitterStack from 'components/organisms/non-controlled-hitter-stacking';
import ShowPlayersExposureWhileOptimized from 'components/molecules/show-players-exposure-while-optimized';
import ProjectedOwnershipForce from 'components/organisms/projected-ownership-force';
import PlayerCombinationStacking from 'components/organisms/player-combination-stacking';
import OptimizeOpener from 'components/molecules/optimize-opener';
import RelaxBuildRules from 'components/molecules/relax-build-rules';
import PlayerGroupingsSwitch from 'components/molecules/player-groupings-switch';
import ProjectionBoostRule from 'components/organisms/projection-boost-rule';
import LimitOnePitcherPerGame from 'components/molecules/limit-one-pitcher-per-game';

class PlayersDashboard extends Component {
    render() {
        return (
            <div>
                <div className="filters-table">
                    <OptimizeOpener />
                    <div className="filters-top">
                        <div className="filters-top-holder">
                            <FilterBySalary useDragging={true} />
                            <FilterByPoints useDragging={true} />
                            <SelectSalaryCap useDragging={true} />
                            <ProjectedOwnershipCap useDragging={true} />
                            <LineupsQuantity useDragging={true} />
                        </div>
                        <div className="filters-cell select-cell">
                            <ExposureMode />
                            <ProjectionPointsType
                                options={{
                                    userPoints: 'Fantasy Points',
                                    grades: 'Rating',
                                }}
                            />
                            <UniquePlayersQuantity />
                            <SelectLineupResolver />
                        </div>
                    </div>
                    <div className="filters-bottom">
                        <div className="filters-cell">
                            <OpposingPitchers />
                        </div>
                        <div className="filters-cell">
                            <FilterByOrder />
                        </div>
                        <div className="filters-cell">
                            <FilterByConfirmed />
                        </div>
                        <div className="filters-cell">
                            <ProjectedOwnershipForce />
                        </div>
                        <div className="filters-cell">
                            <PrioritizeCompletingLineupsAboveExp />
                        </div>
                        <div className="filters-cell">
                            <RangeOfOutcomesByPositions
                                useDragging={true}
                                positionsGroupName="hitter"
                                config={{sport: 'mlb'}}
                            />
                        </div>
                        <div className="filters-cell">
                            <RangeOfOutcomesByPositions
                                useDragging={true}
                                positionsGroupName="pitcher"
                                config={{sport: 'mlb'}}
                            />
                        </div>
                        <div className="filters-cell">
                            <LimitOnePitcherPerGame />
                        </div>
                        <div className="filters-cell">
                            <ShowPlayersExposureWhileOptimized />
                        </div>
                        <RelaxBuildRules className="filters-cell" />
                    </div>
                    <OptimizeButton />
                </div>
                <NonControlledHitterStack />
                <MLBHittersStack />
                <PlayerGroupingsSwitch>
                    <PlayerCombinationStacking />
                    <ProjectionBoostRule />
                </PlayerGroupingsSwitch>
            </div>
        );
    }
}

export {PlayersDashboard};
